module.exports = __webpack_public_path__ + "static/media/facebook-logo.fa65c8f1.png";